(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    if (!window.PureserreExpressCheckoutInitialized) {
    window.PureserreExpressCheckoutInitialized = true;

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-express-checkout-trigger]');
      if (!trigger) return;

      const productForm = trigger.closest('product-form-component');
      const form = productForm?.querySelector('form');
      if (!productForm || !form) return;

      const addToCartButton = productForm.querySelector('[ref="addToCartButton"]');
      if (addToCartButton?.disabled) return;

      productForm.dataset.expressCheckoutPending = 'true';
      window.PureserreSkipCartDrawerOnce = true;
      form.requestSubmit();
    });

    document.addEventListener('cart:update', (event) => {
      const productForm = document.querySelector('product-form-component[data-express-checkout-pending="true"]');
      if (!productForm) return;

      const didError = event.detail?.data?.didError;
      const eventProductId = event.detail?.data?.productId?.toString();
      const formProductId = productForm.dataset.productId?.toString();

      if (eventProductId && formProductId && eventProductId !== formProductId) return;

      delete productForm.dataset.expressCheckoutPending;
      window.PureserreSkipCartDrawerOnce = false;

      if (didError) return;

      window.location.href = '/checkout';
    });

    document.addEventListener('cart:error', () => {
      const productForm = document.querySelector('product-form-component[data-express-checkout-pending="true"]');
      if (!productForm) return;

      delete productForm.dataset.expressCheckoutPending;
      window.PureserreSkipCartDrawerOnce = false;
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cross-sell"] && !Shopify.designMode) return;
  try {
    (function () {
  function handleCsAdd(btn) {
    var variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled) return;

    btn.disabled = true;
    var origText = btn.textContent;
    btn.textContent = '…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw d; });
        return fetch('/cart.js').then(function (r2) { return r2.json(); });
      })
      .then(function (cart) {
        btn.textContent = '✓ Ajouté';
        btn.classList.add('cs-item__add--added');

        // Update cart icon bubble
        var cartIcon = document.querySelector('cart-icon');
        if (cartIcon && typeof cartIcon.renderCartBubble === 'function') {
          cartIcon.renderCartBubble(cart.item_count, false, true);
        }

        // Dispatch cart:update so cart drawer refreshes
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { cart: cart }
        }));

        setTimeout(function () {
          btn.textContent = origText;
          btn.classList.remove('cs-item__add--added');
          btn.disabled = false;
        }, 2500);
      })
      .catch(function (err) {
        console.error('[cross-sell] add to cart error', err);
        btn.textContent = '✗';
        setTimeout(function () {
          btn.textContent = origText;
          btn.disabled = false;
        }, 1500);
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cs-item__add');
    if (btn) handleCsAdd(btn);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pi-testimonial"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.pi-temoignage').forEach(function(fig) {
    fig.querySelectorAll('.pi-temoignage__toggle').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var short = fig.querySelector('.pi-temoignage__short');
        var full = fig.querySelector('.pi-temoignage__full');
        var expanded = short.hidden;
        short.hidden = !expanded;
        full.hidden = expanded;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-weight"] && !Shopify.designMode) return;
  try {
    (function() {
    function updateWeight() {
      var containers = document.querySelectorAll('[data-product-weight]');
      containers.forEach(function(el) {
        var form = el.closest('form[action*="/cart/add"]') || el.closest('[data-product-form]') || el.closest('product-form') || document;
        var select = document.querySelector('select[name="id"]');
        var radio = document.querySelector('input[name="id"]:checked');
        var variantId = (radio ? radio.value : null) || (select ? select.value : null);
        if (!variantId) return;

        var meta = window.__pureserre_variants_weight;
        if (!meta) return;

        var w = meta[variantId];
        if (w != null) {
          var display = w >= 1000 ? (w / 1000).toFixed(1) + ' kg' : w + ' g';
          var valEl = el.querySelector('[data-weight-value]');
          if (valEl) valEl.textContent = display;
          el.style.display = 'block';
        }
      });
    }

    document.addEventListener('change', function(e) {
      if (e.target && (e.target.name === 'id' || e.target.closest('variant-radios') || e.target.closest('variant-select'))) {
        updateWeight();
      }
    });

    document.addEventListener('variant:change', updateWeight);
    document.addEventListener('variantchange', updateWeight);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-testimonial"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.pi-temoignage__short, .pi-temoignage__full').forEach(function(el) {
    var btn = el.querySelector('button');
    var txt = el.childNodes[0];
    if (txt && txt.nodeType === 3) {
      txt.textContent = txt.textContent.replace(/[\u201C\u201D\u00AB\u00BB\u2018\u2019"]/g, '');
    }
  });
  } catch(e) { console.error(e); }
})();

})();
